import {
  ArrowLeftCircle,
  InfoEmpty,
  MessageText,
  MoreHorizCircle,
  Trash,
} from 'iconoir-react'
import React, { memo, useEffect, useMemo, useRef, useState } from 'react'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import { useNavigate, useParams } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import PDFViewer from '../../components/PDFViewer/PDFViewer'
import { getExtensionFile } from '../../utils/common'
import { useMediaQuery } from 'react-responsive'
import moment from 'moment'
import { DATE_FORMAT_DEFAULT } from '../../utils/constants'
import { EmptyText, WordBreak } from '../../components/common/CellText'
import FileItem from '../../components/FileItemComponent/FileItem'
import LinkedTask from '../../components/Linked/LinkedTask'
import LinkedWork from '../../components/Linked/LinkedWork'
import PeopleTag from '../../components/PeopleTag'
import { Menu, MenuItem, useTheme } from '@mui/material'
import CommentModal from './commentModal'
import ListComment from './ListComment'
import AlertDialog from '../../components/common/AlertDialog'
import PopupHandleDocumentIncoming from './PopupHandleDocumentIncoming'
import {
  AiOutlineComment,
  AiOutlineEdit,
  AiOutlineDelete,
  AiOutlineQuestionCircle,
  AiOutlineSolution,
  AiOutlineForm,
  AiOutlineFileText,
} from 'react-icons/ai'
import { Modal, message } from 'antd'
import InternalDocumentIncomingUpdate from './InternalDocumentIncomingUpdate'
import queryString from 'query-string'
import { DOCUMENT_TYPE } from '../../constants'
import { toJS } from 'mobx'
import utils from '../../utils'
import Message from '../../components/common/Message'
import PopupPhanPhatDocumentIncoming from './PopupPhanPhatDocumentIncoming'
import { MdOutlineTask } from 'react-icons/md'

const InternalDocumentIncomingDetail = props => {
  const { internalDocumentStore } = props
  const [messageCreate, setMessageCreate] = useState('')
  const [openMessage, setOpenMessage] = useState(false)
  const [severity, setSeverity] = useState('')
  const createMessage = (messageCreate, openMessage, severity) => {
    setMessageCreate(messageCreate)
    setOpenMessage(openMessage)
    setSeverity(severity)
  }
  const {
    selectedInternalDocumentIncoming,
    internalDocumentCommentList,
    handlerAssignList,
    combinerAssignList,
    followerAssignList,
    getInternalDocumentComment,
    deleteInternalDocumentComment,
  } = internalDocumentStore
  const {
    authority_issued_id,
    agency_issued,
    date_issued,
    incoming_date,
    incoming_number,
    document_number,
    signer,
    title,
    attachments,
    linkedTask,
    linkedWork,
    start_date,
    end_date,
  } = selectedInternalDocumentIncoming
  const { documentId } = useParams()
  const [open, setOpen] = React.useState(false)
  const navigate = useNavigate()
  const [attachmentForView, setAttachmentForView] = useState()
  const commentRef = useRef(null)
  const [openCmt, setOpenCmt] = useState(false)
  const [openUpdate, setOpenUpdate] = useState(false)
  const [openMore, setOpenMore] = useState(false)
  const [openCmtDel, setOpenCmtDel] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)
  const [loading, setLoading] = useState(false)
  const [loadingCmt, setLoadingCmt] = useState(false)
  const [deleteItem, setDeleteItem] = useState({
    open: false,
    id_comment: '',
  })
  const opens = Boolean(anchorEl)
  const commentInDocListNotDeleted = internalDocumentCommentList?.filter(
    item => item.deleted !== true
  )
  const commentInDocListDeleted = internalDocumentCommentList?.filter(
    item => item.deleted === true
  )
  const isTabletOrMobile = useMediaQuery({
    query: '(max-width: 1299px)',
  })
  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }
  const handleDeleteComment = async () => {
    setDeleteItem({ open: false, comment_id: '' })
    try {
      setLoading(true)
      await deleteInternalDocumentComment(documentId, deleteItem.id_comment)
      await getInternalDocumentComment(documentId)
      createMessage('Xóa ý kiến thành công!', true, 'success')
    } catch (err) {
      createMessage(err.vi, true, 'error')
    } finally {
      setLoading(false)
    }
  }

  const handleClose = () => {
    setAnchorEl(null)
  }
  let menu = (
    <Menu
      id="basic-menu"
      anchorEl={anchorEl}
      open={opens}
      onClose={handleClose}
      MenuListProps={{
        'aria-labelledby': 'basic-button',
      }}>
      {openMore ? (
        <MenuItem
          sx={{
            color: '#0073C7 !important',
            borderBottom: '1px solid rgba(0,0,0,0.05)',
            fontSize: '12px',
          }}
          onClick={() => {
            setOpenMore(false)
            setOpenCmtDel(false)
            handleClose()
          }}>
          <Trash width={12} height={14} className="mr-1" />
          Ẩn ý kiến đã xóa
        </MenuItem>
      ) : (
        <MenuItem
          onClick={() => {
            setOpenMore(true)
            setOpenCmtDel(true)
            handleClose()
          }}
          sx={{
            color: '#0073C7 !important',
            borderBottom: '1px solid rgba(0,0,0,0.05)',
            fontSize: '12px',
          }}>
          <Trash width={12} height={14} className="mr-1" />
          Hiện ý kiến đã xóa
        </MenuItem>
      )}
    </Menu>
  )
  useEffect(() => {
    ;(async () => {
      try {
        await Promise.all([
          internalDocumentStore.getInternalDocumentIncomingById(documentId),
          getInternalDocumentComment(documentId),
        ])
      } catch (err) {
        navigate('/internal-document/incoming-document')
        // console.log(err)
      } finally {
      }
    })()
    return () => {
      internalDocumentStore.clearSelectedInternalDocumentIncoming()
      internalDocumentStore.clearAssignList()
      internalDocumentStore.clearInternalDocumentCommentList()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documentId])

  useEffect(() => {
    if (!attachments) return
    setAttachmentForView(
      attachments.find(file =>
        ['pdf', 'doc', 'docx'].includes(getExtensionFile(file.name))
      )
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attachments])

  const renderAuthorityIssuedList = (authorityIssuedId, agencyIssued) => {
    const authorityList = []
    if (authorityIssuedId) {
      authorityList.push(authorityIssuedId.name)
    }
    if (agencyIssued && agencyIssued !== authorityIssuedId?.name) {
      authorityList.push(agencyIssued)
    }
    if (authorityIssuedId || agencyIssued) {
      return authorityList.join(', ')
    }
    return <EmptyText>Không có.</EmptyText>
  }

  const theme = useTheme()
  const renderAttachment = useMemo(
    () => (
      <PDFViewer
        fileId={attachmentForView?.id}
        customStyleObj={{ height: isTabletOrMobile ? 500 : 1000 }}
        fileType={getExtensionFile(attachmentForView?.name)}
      />
    ),
    [attachmentForView]
  )
  const handleClickOpenInfo = e => {
    e.stopPropagation()
    setOpen(true)
    document.body.style.overflow = 'hidden'
  }

  const handleCloseInfo = () => {
    setOpen(false)
    document.body.style.overflow = 'auto'
  }

  const executeScroll = () => commentRef.current.scrollIntoView()

  const descriptionElementRef = useRef(null)
  useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef
      if (descriptionElement !== null) {
        descriptionElement.focus()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  const { confirm } = Modal
  const handleDeleteDoc = async () => {
    try {
      await internalDocumentStore.deleteIncomingInternalDocumentById(documentId)
    } catch (err) {
      // console.log(err)
    } finally {
      message.success('Xóa văn bản thành công!')
      navigate(-1)
    }
  }
  const [isVisiblePopupHandleDocument, setIsVisiblePopupHandleDocument] =
    useState(false)
  const [isVisiblePopupPhanPhat, setIsVisiblePopupPhanPhat] = useState(false)
  const showConfirmDeleteDoc = () => {
    confirm({
      title: 'Bạn có muốn xóa văn bản này không?',
      icon: (
        <AiOutlineQuestionCircle
          style={{ color: 'red', width: '30px', height: '30px' }}
        />
      ),
      okText: 'Đồng ý',
      cancelText: 'Không',
      okType: 'danger',
      onOk() {
        handleDeleteDoc()
      },
    })
  }

  const [commentLeaderList, setCommentLeaderList] = useState([])

  useEffect(() => {
    if (handlerAssignList.length === 0) return
    const commentList = toJS(internalDocumentCommentList).filter(
      cmt => !cmt.deleted && cmt.user_name === handlerAssignList[0].id
    )
    setCommentLeaderList(commentList)
  }, [internalDocumentCommentList, handlerAssignList])

  return (
    <div style={{ background: theme.background.base }}>
      <div
        className="flex items-center p-[20px] gap-[22px] fixed w-full z-50"
        style={{
          background: theme.background.header,
          color: theme.color.text1,
        }}>
        <ArrowLeftCircle
          className="flex-shrink-0"
          onClick={() => {
            navigate(-1)
          }}
        />
        <span
          className="font-bold text-[28px] leading-[29px] "
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            width: '100%',
            whiteSpace: 'nowrap',
            marginRight: '5px',
            lineHeight: '35px',
          }}>
          {title}
        </span>
      </div>
      <div className="py-[20px] pt-20">
        <div className={`px-5 }`}>
          <div className="flex justify-between">
            <div
              className="flex justify-center gap-x-2 items-center mt-5 bg-[rgba(0,115,199,0.07);] py-[10px] w-[calc(50%-10px)] text-primary px-[14px] rounded-full text-sm leading-5 cursor-pointer font-medium"
              onClick={handleClickOpenInfo}>
              <div>
                <InfoEmpty />
              </div>
              <span onClick={handleClickOpenInfo}>Thông tin</span>
            </div>
            <div
              className="flex justify-center gap-x-2  items-center mt-5 bg-[rgba(22,25,44,0.07)] py-[10px] w-[calc(50%-10px)]  px-[14px] rounded-full text-sm leading-5 font-medium"
              onClick={() =>
                internalDocumentCommentList?.length > 0
                  ? executeScroll()
                  : createMessage('Chưa có ý kiến!', true, 'warning')
              }>
              <div>
                <MessageText />
              </div>
              <span>Ý kiến</span>
            </div>
          </div>

          <div className="!w-[100%] mt-[14px] pb-[10px] ">
            {renderAttachment}
          </div>
          {/* <div
            ref={commentRef}
            style={{ wordWrap: ' break-word' }}
            className="pb-[80px]">
            {internalDocumentCommentList.map(comment => (
              <div className="px-[14px]  mt-[14px] py-5 bg-lightBlue rounded ">
                <div className="flex justify-between items-center mb-[14px]">
                  <div className="text-xs font-semibold leading-5 text-primaryText">
                    {' '}
                    {getNameInCapitalize(comment.name_uppercase)}
                  </div>
                  <div className="text-lightText text-[8px] font-medium">
                    {date_format.renderTime(comment.created_at)}
                  </div>
                </div>
                <div className="text-sm font-normal leading-6">
                  {comment.content.trim()}
                </div>
              </div>
            ))}
          </div> */}
          <div ref={commentRef} style={{ paddingBottom: '80px' }}>
            {commentInDocListDeleted?.length > 0 ? (
              <>
                <div className="mt-4 text-sm flex items-center">
                  <div className="font-semibold leading-5 text-labelForm">
                    Danh sách ý kiến
                  </div>
                  <MoreHorizCircle
                    className="text-primary ml-2"
                    onClick={handleClick}
                  />
                  {menu}
                </div>
                {openCmtDel ? (
                  <ListComment
                    loadingCmt={loadingCmt}
                    commentList={commentInDocListDeleted}
                    setDeleteItem={setDeleteItem}
                  />
                ) : (
                  ''
                )}
                <ListComment
                  loadingCmt={loadingCmt}
                  commentList={commentInDocListNotDeleted}
                  setDeleteItem={setDeleteItem}
                />
              </>
            ) : (
              <>
                {commentInDocListNotDeleted?.length > 0 && (
                  <>
                    <div className="mt-4 text-sm flex items-center">
                      <div className="font-semibold leading-5 text-labelForm">
                        Danh sách ý kiến
                      </div>
                      <MoreHorizCircle
                        className="text-primary ml-2"
                        onClick={handleClick}
                      />
                      {menu}
                    </div>
                    {openCmtDel ? (
                      <ListComment
                        loadingCmt={loadingCmt}
                        commentList={commentInDocListDeleted}
                        setDeleteItem={setDeleteItem}
                      />
                    ) : (
                      ''
                    )}
                    <ListComment
                      loadingCmt={loadingCmt}
                      commentList={commentInDocListNotDeleted}
                      setDeleteItem={setDeleteItem}
                    />
                  </>
                )}
              </>
            )}
          </div>
        </div>

        <Dialog
          open={open}
          onClose={handleCloseInfo}
          scroll={'paper'}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
          className="doc-popup"
          fullWidth
          sx={{
            '& .MuiDialog-container': {
              '& .MuiPaper-root': {
                width: '100vw',
                maxWidth: '100vw', // Set your width here
                mx: 0,
              },
            },
          }}>
          <DialogTitle
            id="scroll-dialog-title"
            className="text-xl font-bold text-[#23374D] !py-9"
            sx={{
              fontWeight: 700,
            }}>
            <span className="font-bold">Thông tin</span>
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              id="scroll-dialog-description"
              ref={descriptionElementRef}
              tabIndex={-1}
              className="">
              <table
                style={{ color: '#16192C' }}
                className="doc-table-vertical font-semibold text-sm leading-5 text-[#16192C]">
                <tr>
                  <th style={{ paddingBottom: 14 }}>Số hiệu:</th>
                  <td className="font-normal" style={{ paddingBottom: 14 }}>
                    {document_number}
                  </td>
                </tr>
                <tr>
                  <th style={{ paddingBottom: 14 }}>Số đến:</th>
                  <td className="font-normal" style={{ paddingBottom: 14 }}>
                    {incoming_number}
                  </td>
                </tr>
                <tr>
                  <th style={{ paddingBottom: 14 }}>Ngày ban hành: </th>
                  <td className="font-normal" style={{ paddingBottom: 14 }}>
                    {date_issued ? (
                      <>
                        <span>
                          {moment(date_issued).format(DATE_FORMAT_DEFAULT)}
                        </span>
                      </>
                    ) : (
                      <EmptyText>Không có.</EmptyText>
                    )}
                  </td>
                </tr>
                <tr>
                  <th style={{ paddingBottom: 14 }}>Ngày đến: </th>
                  <td className="font-normal" style={{ paddingBottom: 14 }}>
                    {incoming_date ? (
                      <>
                        <span>
                          {moment(incoming_date).format(DATE_FORMAT_DEFAULT)}
                        </span>
                      </>
                    ) : (
                      <EmptyText>Không có.</EmptyText>
                    )}
                  </td>
                </tr>
                <tr>
                  <th style={{ paddingBottom: 14 }}>Người ký: </th>
                  <td className="font-normal" style={{ paddingBottom: 14 }}>
                    {signer ? signer : <EmptyText>Không có.</EmptyText>}
                  </td>
                </tr>
                <tr>
                  <th style={{ paddingBottom: 14 }}>CQ ban hành: </th>
                  <td className="font-normal" style={{ paddingBottom: 14 }}>
                    {WordBreak(
                      renderAuthorityIssuedList(
                        authority_issued_id,
                        agency_issued
                      )
                    )}
                  </td>
                </tr>
                <tr>
                  <th style={{ paddingBottom: 14 }}>Tài liệu đính kèm: </th>
                  <td className="font-normal" style={{ paddingBottom: 14 }}>
                    {attachments ? (
                      attachments.map(file => (
                        <FileItem
                          file={file}
                          key={file.id}
                          file_id={file.id}
                          file_name={file.name}
                          file_type={getExtensionFile(file.name)}
                        />
                      ))
                    ) : (
                      <EmptyText>Không có.</EmptyText>
                    )}
                  </td>
                </tr>
                <tr>
                  <th style={{ paddingBottom: 14 }}>Liên kết nhiệm vụ: </th>
                  <td className="font-normal" style={{ paddingBottom: 14 }}>
                    <LinkedTask linkedTaskList={linkedTask} />
                  </td>
                </tr>
                <tr>
                  <th style={{ paddingBottom: 14 }}>Liên kết công việc: </th>
                  <td className="font-normal" style={{ paddingBottom: 14 }}>
                    <LinkedWork linkedWorkList={linkedWork} />
                  </td>
                </tr>
              </table>
              <div className="font-semibold text-sm leading-5 text-[#16192C]">
                <div style={{ paddingBottom: 14 }}>
                  <div>Lãnh đạo xử lý:</div>
                  <div className="flex flex-wrap mt-2 font-normal gap-x-2 gap-y-3">
                    {handlerAssignList.length !== 0 ? (
                      handlerAssignList.map(item => <PeopleTag el={item} />)
                    ) : (
                      <EmptyText>Không có.</EmptyText>
                    )}
                  </div>
                </div>
                <div style={{ paddingBottom: 14 }}>
                  <div className="table-title">Người xử lý:</div>
                  <div className="flex flex-wrap mt-2 font-normal gap-x-2 gap-y-3">
                    {combinerAssignList.length !== 0 ? (
                      combinerAssignList.map(item => (
                        <PeopleTag key={item.id} el={item} />
                      ))
                    ) : (
                      <EmptyText>Không có.</EmptyText>
                    )}
                  </div>
                </div>
                <div style={{ paddingBottom: 14 }}>
                  <div className="table-title">Phối hợp/theo dõi:</div>
                  <div className="flex flex-wrap mt-2 font-normal gap-x-2 gap-y-3">
                    {followerAssignList.length !== 0 ? (
                      followerAssignList.map(item => <PeopleTag el={item} />)
                    ) : (
                      <EmptyText>Không có.</EmptyText>
                    )}
                  </div>
                </div>
                <tr>
                  <th style={{ paddingBottom: 14 }}>Ngày bắt đầu: </th>
                  <td>
                    {start_date ? (
                      <span className="font-normal ml-2">
                        {' '}
                        {moment(start_date).format(DATE_FORMAT_DEFAULT)}
                      </span>
                    ) : (
                      <span className="font-normal ml-2">Không có.</span>
                    )}
                  </td>
                </tr>
                <tr>
                  <th style={{ paddingBottom: 28 }}>Ngày kết thúc: </th>
                  <td>
                    {end_date ? (
                      <span className="font-normal ml-2">
                        {' '}
                        {moment(end_date).format(DATE_FORMAT_DEFAULT)}
                      </span>
                    ) : (
                      <span className="font-normal ml-2">Không có.</span>
                    )}
                  </td>
                </tr>
              </div>
            </DialogContentText>
          </DialogContent>

          <DialogActions>
            <Button
              sx={{ fontWeight: 600 }}
              onClick={handleCloseInfo}
              className="pb-6 text-sm font-semibold leading-5 text-primary">
              Đóng
            </Button>
          </DialogActions>
        </Dialog>
        <CommentModal
          createMessage={createMessage}
          open={openCmt}
          handleClose={() => {
            setOpenCmt(false)
          }}
          inDocCode={documentId}
          // onCommentSuccess={onCommentSuccess}
        />
        <InternalDocumentIncomingUpdate
          createMessage={createMessage}
          open={openUpdate}
          handleClose={() => setOpenUpdate(false)}
        />
        <PopupHandleDocumentIncoming
          createMessage={createMessage}
          isVisiblePopupHandleDocument={isVisiblePopupHandleDocument}
          handleCancelHandleDocument={() =>
            setIsVisiblePopupHandleDocument(false)
          }
          handleCloseHandleDocument={() =>
            setIsVisiblePopupHandleDocument(false)
          }
        />
        <PopupPhanPhatDocumentIncoming
          createMessage={createMessage}
          isVisiblePopupPhanPhat={isVisiblePopupPhanPhat}
          handleCancelPhanPhatDocument={() => setIsVisiblePopupPhanPhat(false)}
          handleClosePhanPhatDocument={() => setIsVisiblePopupPhanPhat(false)}
        />
        <Message
          message={messageCreate}
          openMessage={openMessage}
          severity={severity}
          closeMessage={() => {
            setOpenMessage(false)
          }}
        />
        <footer
          style={{
            position: 'fixed',
            bottom: 0,
            backgroundColor: 'white',
            borderTopRightRadius: '10px',
            borderTopLeftRadius: '10px',
            padding: '15px 0',
          }}
          className="flex items-center justify-between px-5 w-full py-4 shadow-[0px_0px_8px_rgba(0,0,0,0.25)] ">
          <div className="flex justify-between  w-full h-full">
            <div className="block text-center w-[70px]">
              <div
                className="bg-[rgba(0,115,199,0.07);] text-blue-500 inline-block hover:bg-cyan-400 hover:text-white py-[8px] text-center px-[8px] rounded-full text-sm font-medium"
                onClick={() => setOpenCmt(true)}>
                <AiOutlineComment style={{ width: '20px', height: '20px' }} />
              </div>
              <div style={{ fontSize: '11px' }}>Ý kiến</div>
            </div>
            <div className="block text-center w-[70px]">
              <div
                className="bg-[rgba(0,115,199,0.07);] text-blue-500 inline-block hover:bg-cyan-400 hover:text-white py-[8px] text-center px-[8px] rounded-full text-sm font-medium"
                onClick={() => {
                  const documentList = attachments.map(
                    el => el.id + '/' + el.name
                  )
                  const queryStringParams = queryString.stringify(
                    {
                      document_list: documentList,
                      incoming_number: incoming_number,
                      document_title: title,
                      document_code: documentId,
                      document_type: DOCUMENT_TYPE.INCOMING,
                      comments_leader: commentLeaderList.map(
                        cmt => cmt.content
                      ),
                      leader_name:
                        handlerAssignList.length > 0 &&
                        utils.getNameInCapitalize(
                          handlerAssignList[0].full_name
                        ),
                    },
                    { arrayFormat: 'index' }
                  )
                  navigate(`/work?${queryStringParams}`)
                }}>
                <AiOutlineSolution style={{ width: '20px', height: '20px' }} />
              </div>
              <div style={{ fontSize: '11px' }}>CV từ VB</div>
            </div>
            <div className="block text-center w-[70px]">
              <div
                className="bg-[rgba(0,115,199,0.07);] text-blue-500 inline-block hover:bg-cyan-400 hover:text-white py-[8px] text-center px-[8px] rounded-full text-sm font-medium"
                onClick={() => {
                  navigate(
                    `/mission/create?document_code=${documentId}&title=${title}&type=INCOMING`
                  )
                }}>
                <MdOutlineTask style={{ width: '20px', height: '20px' }} />
              </div>
              <div style={{ fontSize: '11px' }}>NV từ VB</div>
            </div>
            <div className="block text-center w-[70px]">
              <div
                className="hover:bg-cyan-400 inline-block bg-[rgba(0,115,199,0.07);] text-blue-500 hover:text-white py-[8px] text-center px-[8px] rounded-full text-sm font-medium"
                onClick={() => setIsVisiblePopupHandleDocument(true)}>
                <AiOutlineForm style={{ width: '20px', height: '20px' }} />
              </div>
              <div style={{ fontSize: '11px' }}>Xử lý VB</div>
            </div>
            <div className="block text-center w-[70px]">
              <div
                className="hover:bg-cyan-400 inline-block bg-[rgba(0,115,199,0.07);] text-blue-500 hover:text-white py-[8px] text-center px-[8px] rounded-full text-sm font-medium"
                onClick={() => setIsVisiblePopupPhanPhat(true)}>
                <AiOutlineFileText style={{ width: '20px', height: '20px' }} />
              </div>
              <div style={{ fontSize: '11px' }}>Phân phát</div>
            </div>
            <div className="block text-center w-[70px]">
              <div
                className="hover:bg-cyan-400 inline-block bg-[rgba(0,115,199,0.07);] text-blue-500 hover:text-white py-[8px] text-center px-[8px] rounded-full text-sm font-medium"
                onClick={() => setOpenUpdate(true)}>
                <AiOutlineEdit style={{ width: '20px', height: '20px' }} />
              </div>
              <div style={{ fontSize: '11px' }}>Sửa</div>
            </div>
            <div className="block text-center w-[70px]">
              <div
                className="hover:bg-cyan-400 inline-block bg-[rgba(0,115,199,0.07);] text-red-500 hover:text-white py-[8px] text-center px-[8px] rounded-full text-sm font-medium"
                onClick={() => showConfirmDeleteDoc()}>
                <AiOutlineDelete style={{ width: '20px', height: '20px' }} />
              </div>
              <div style={{ fontSize: '11px' }}>Xóa</div>
            </div>
          </div>
        </footer>
        <AlertDialog
          open={deleteItem.open}
          handleClose={() => setDeleteItem({ open: false, comment_id: '' })}
          handleDelete={handleDeleteComment}
        />
      </div>
    </div>
  )
}

export default memo(
  inject('internalDocumentStore')(observer(InternalDocumentIncomingDetail))
)
